export default {
  common: {
    language: 'Sprache',
    logoAlt: 'Zhongze Wissenschaft & Bildung',
    cancel: 'Abbrechen',
  },
  chatService: {
    chatNow: {
      label: 'Jetzt chatten',
    },
    emailGate: {
      title: 'E-Mail erforderlich',
      desc: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um den Chat fortzusetzen.',
      successMessage: 'E-Mail gesendet. Sie können den Chat fortsetzen.',
    },
  },
  nav: {
    home: 'Startseite',
    products: 'Produkte',
    software: 'Software',
    eduServices: 'Bildungsdienstleistungen',
    support: 'Service & Support',
    cooperation: 'Bildungskooperation',
    about: 'Über uns',

    // Sub-menus & Mega Menu
    learningPlatform: 'Zhongze Lernplattform',
    cloudPlatform: 'Zhongze Cloud-Plattform',
    laserSoftware: 'Spezialsoftware für Lasergeräte',
    makerK12: 'Maker Education – Schule (K-12)',
    archVocational: 'Architekturmodelle – Berufsbildung (Sek. II)',
    cultHigherVoc: 'Kultur- & Kreativdesign – Höhere Berufsbildung',
    artsUni: 'Kunst & Kunsthandwerk – Hochschule',
    afterSales: 'After-Sales-Service',
    faq: 'Häufige Fragen',
    download: 'Download-Center',
    companyIntro: 'Unternehmensprofil',
    news: 'Neuigkeiten',
    contact: 'Kontakt',
    device: 'Geräte',
    kits: 'Kits',
    softwareService: 'Software-Services',
    accessories: 'Zubehör',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: 'Kit-System',
    kitsAccessories: 'Kit-Zubehör',
    courses: 'Kurse',
  },
  aboutPage: {
    seoTitle: 'Über uns - Zhongze',
    banner: {
      title: 'Über uns',
    },
    about: {
      title: 'Über uns',
      body: 'Zhongze Education wurde 2015 gegründet. Dank der engen Zusammenarbeit mit China Unicom International in Hongkong haben wir auf Basis europäischer und amerikanischer STEAM-Kurse ein Maker-Bildungssystem entwickelt, das für Kinder in China geeignet ist. Durch soziales Lernen und praktische Projekte helfen wir Kindern, Grenzen zu überwinden und Großartiges zu schaffen. Mit „STEAM-Bildung + Maker-Space“ als Kern und der Mission „Zukünftige Gestalter:innen fördern“ konzentrieren wir uns auf Technologie- und Kreativitätsbildung für Kinder und Jugendliche von 3 bis 16 Jahren. Wir bauen Innovationslernräume auf und entwickeln eigene Produkte und Kurse für die MINT/STEAM-Bildung. Rund um Designsoftware, Lasergravur, Programmieren und weitere Themen schaffen wir ein einzigartiges Ökosystem für Bildungsinhalte und einen geschlossenen Produktkreislauf. So erwerben Kinder in realen Projekten die Kernkompetenzen für die Zukunft! Unsere Vision ist es, Treiber internationaler Innovationsbildung zu sein. Wir bieten nicht nur Kurse und Maker-Umgebungen, sondern eine völlig neue Art des Lernens. Wir glauben, dass jedes Kind eine zukünftige Innovatorin bzw. ein zukünftiger Innovator ist: denken wie Wissenschaftler:innen, handeln wie Ingenieur:innen, gestalten kreativ wie Designer:innen und lernen smart zu machen wie Maker.',
    },
    intro: {
      title: 'Warum wir?',
      desc: 'Als Treiber internationaler Innovationsbildung bieten wir Kurse und Maker-Umgebungen – und vor allem eine neue Art des Lernens. Wir glauben, dass jedes Kind eine zukünftige Innovatorin bzw. ein zukünftiger Innovator ist, der sich im Entdecken selbst findet und in der Praxis seine Zukunft gestaltet.',
      features: {
        projectLearning:
          'Projektbasiertes Lernen: In echten Projekten erwerben Kinder die Kernkompetenzen für die Zukunft.',
        interactiveExperiments:
          'Interaktive Experimente: Durch diese Experimente lernen Kinder nicht nur grundlegende naturwissenschaftliche Prinzipien, sondern entwickeln auch Problemlösefähigkeit, Kreativität und Teamgeist.',
      },
    },
    images: {
      aboutAlt: 'Über Zhongze',
      featureIcon1Alt: 'Symbol für projektbasiertes Lernen',
      featureIcon2Alt: 'Symbol für interaktive Experimente',
      introAlt: 'Warum wir',
    },
  },
  newsPage: {
    banner: {
      title: 'Neuigkeiten',
    },
    tabs: [
      { id: 'all', name: 'Alle' },
      { id: 'company', name: 'Unternehmensnews' },
      { id: 'exhibition', name: 'Messe-News' },
      { id: 'industry', name: 'Branchentrends' },
    ],
    items: [
      {
        title:
          'Henghao Laser auf der BETT UK 2025: Laser-Technologie stärkt Bildungsinnovation',
      },
      {
        title:
          'Kern der K-12-Bildungsinnovation: Wie CO2-Laserschneider den STEAM-Unterricht voranbringen',
      },
      {
        title:
          'Henghao-Laser-Kund:innen glänzen mit Light 530 auf der didacta Italia 2025',
      },
      { title: 'Zhongze veröffentlicht neue intelligente Bildungslösungen' },
      {
        title:
          'Bildungstrends der Zukunft: Tiefe Integration von KI und Maker Education',
      },
    ],
  },
  newsInformationPage: {
    banner: {
      title: 'Neuigkeiten',
    },
    tabs: [
      { id: 'all', name: 'Alle' },
      { id: 'company', name: 'Unternehmensnews' },
      { id: 'exhibition', name: 'Messe-News' },
      { id: 'industry', name: 'Branchentrends' },
    ],
    items: [
      {
        title:
          'Zhongze Technology bringt eine neue Generation von Bildungs-Robotik-Kits heraus und setzt neue STEM-Trends',
      },
      {
        title:
          'KI kommt in die Schulen: Wie Programmierbildung logisches Denken stärkt',
      },
      {
        title:
          'Nationaler Jugend-Robotikwettbewerb 2023 erfolgreich abgeschlossen: Von Zhongze unterstützte Teams erzielen Spitzenleistungen',
      },
      {
        title:
          'Zukunft der Bildung: Konzepte für smarte Klassenzimmer im Zuge der digitalen Transformation',
      },
      {
        title:
          'Zhongze Technology schließt strategische Kooperationen mit mehreren Hochschulen und baut gemeinsame KI-Labore auf',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: 'Maker Education',
        desc: 'Bietet Raum zum Experimentieren und Entdecken und fördert die ganzheitliche Entwicklung von Schüler:innen',
      },
      item2: {
        title: 'Das Tor zur Smart Education öffnen',
        desc: 'Von Laseranwendungen bis zu Kursen mit Kits – umfassend für unterschiedliche Lernbedürfnisse.',
      },
      item3: {
        title: 'Kits & Kurse',
        desc: 'Unverzichtbar für effizienteren Unterricht in KI- und STEAM-/Innovationsbildung',
      },
    },
    resources: {
      title: 'Vielfältige STEM-Unterrichtsressourcen',
      tabs: {
        laser: {
          name: 'Laserschneider',
          title: 'Lasergeräte',
          desc1: 'Intelligenter Desktop-Laser zum Schneiden & Gravieren',
          desc2:
            'Hochpräzises Schneiden│Intuitive Bedienung│Effiziente Verarbeitung│Sicher & umweltfreundlich',
        },
        software: {
          name: 'Software',
          title: 'Bildungssoftware',
          desc1: 'Vielseitige All-in-One-Software',
          desc2: 'Cloud-Plattform | Lernplattform | Light Maker',
        },
        ai: {
          name: 'KI-gestützte Unterrichtshilfe',
          title: 'Intelligente Unterrichtsassistenz',
          desc1: 'Echtzeitüberwachung & Gerätewarnungen',
          desc2: 'KI-Assistent | Visualisiertes Dashboard',
        },
        kits: {
          name: 'Kits & Kurse',
          title: 'Umfangreiche Kurs-Kits',
          desc1: 'PBL – projektbasiertes Lernen',
          desc2: 'Lehrmaterialien | Praktisches Arbeiten',
        },
      },
    },
    different: {
      title: 'Was uns besonders macht',
      items: {
        solution: {
          title: 'KI-Lösungen für Bildung',
          desc: 'Verbessert Unterrichtsergebnisse und Lernerlebnis',
        },
        course: {
          title: 'Kurse für kreatives Denken',
          desc: 'Geeignet für Kinder und Jugendliche von 3–16 Jahren',
        },
        product: {
          title: 'Innovations- und MINT-Bildungsprodukte',
          desc: 'Ein-Klick-Laserfertigung',
        },
        space: {
          title: 'Makerspace zum Entdecken',
          desc: 'Vereint Innovation und Praxis',
        },
      },
    },
    creative: {
      title: 'Kreativität antreiben, Zukunft gestalten',
      machineDesc: 'Intelligente Desktop-Laserschneid- und Graviermaschine',
      lightBlue530Desc: 'Intelligente Blaulaser-Schneid- und Graviermaschine',
      markM20Desc: 'Hochpräzise Laser-Markiermaschine',
      light640Desc: 'Professionelle Desktop-Laserschneid- und Graviermaschine',
    },
    innovation: {
      title: 'Wie fördern wir innovatives Lernen?',
      desc: 'Zhongze Wissenschaft & Bildung engagiert sich für die Entwicklung hochwertiger Produkte für Innovations- und MINT-Bildung, darunter Laserschneider. Diese Produkte unterstützen Schüler:innen dabei, in den Bereichen Wissenschaft, Technologie, Ingenieurwesen, Kunst und Mathematik praxisnah zu lernen.',
      items: {
        steam: 'STEAM',
        coding: 'Programmieren',
        light530: 'Mit Light 530',
        robotics: 'Robotik',
      },
    },
    bottomBanner: {
      title: 'KI-Bildung in die Praxis bringen',
      subtitle:
        'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
      desc: 'Fokussiert auf maßgeschneiderte Laserprodukte und technische Services und unterstützt Hochschulen und Unternehmen bei der Integration von „KI+Bildung“.',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: 'Spezialsoftware für Lasergeräte  Light Maker',
      bannerDesc:
        'Professionelle Software für Lasergeräte – einfach und effizient, mit Fokus auf Schneiden und Gravieren.',
      bannerImageAlt: 'Light Maker Benutzeroberfläche',
      creationTitle: 'Kreatives Gestalten ganz einfach',
      features: {
        proDesignTool: 'Design-Tools auf Profi-Niveau',
        highPrecisionParams: 'Hochpräzise Parametereinstellungen',
        multiDeviceControl: 'Mehrgeräte-Verwaltung und -Steuerung',
        assetLibrary: 'Leistungsstarkes Asset-Bibliotheksmanagement',
      },
      intro: {
        imageAlt: 'Funktionsübersicht',
        items: {
          item1: {
            title: 'Leistungsstarkes und einfach zu bedienendes Designsystem',
            desc: 'Leistungsstarke Kreativsoftware, kompatibel mit hochwertigen Designs in JPG, DXF, AI, DST, PNG, BMP, TIF und SVG.',
          },
          item2: {
            title: 'Professionalität',
            desc: 'Professionelle Zeichenfunktionen für jede Fertigungsanforderung – ob komplexes Design oder einfacher Schnitt, alles lässt sich mühelos umsetzen.',
          },
        },
      },
      downloadTitle: 'Software-Download',
      downloadButton: 'Herunterladen und ausprobieren',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'Zhongze Lernplattform',
      bannerDescLine1:
        'Die Zhongze Lernplattform ist ein innovatives Online-Lernwerkzeug und bietet Schüler:innen und Lehrkräften eine umfassende Lösung für Bildungssoftware.',
      bannerDescLine2:
        'Ob auf Mobilgeräten oder am Computer – Nutzer:innen können unsere Plattform einfach aufrufen und verwenden.',
      bannerImageAlt: 'Benutzeroberfläche der Zhongze Lernplattform',
      exploreTitle:
        'Unendliche Möglichkeiten entdecken, eine großartige Zukunft schaffen',
      exploreTabs: [
        { name: 'Erstellen' },
        { name: 'Erste Schritte' },
        { name: 'Modellierung lernen' },
        { name: 'Ein-Klick-Erstellung' },
        { name: 'KI-Bilderzeugung' },
      ],
      tabContentAlt: 'Funktionsübersicht',
      introTitle: 'Innovative Lernplattform',
      introItems: [
        {
          title: 'Neues, effizientes Lernerlebnis',
          desc: 'Die Zhongze Lernplattform integriert Kurslernen, Grafikdesign und Laserschneiden in einer All-in-One-Lösung. Die kartenbasierte Oberfläche ist klar und intuitiv, die Bedienung flüssig – so gelingt der nahtlose Übergang von kreativem Design zur realen Fertigung: effizient und leicht zu erlernen.',
        },
        {
          title: 'Intelligent und bequem – stressfrei für Einsteiger:innen',
          desc: 'Integrierte umfangreiche Bildbibliothek und intelligente Parameter-Presets ermöglichen Ein-Klick-Erstellung – Einsteiger:innen kommen in Sekunden zurecht. Detaillierte Schritt-für-Schritt-Anleitungen in der mobilen App senken die Einstiegshürde; Cloud-Monitoring überwacht Geräte in Echtzeit und sorgt durchgehend für Unterrichtssicherheit.',
        },
      ],
      introImageAlt: 'Innovative Lernplattform',
      galleryAlt: 'Plattformansicht',
      downloadTitle: 'Software-Download',
      downloadApps: [
        { name: 'Zhongze Plattform-App' },
        { name: 'Zhongze Designsoftware (PC)' },
      ],
      downloadButtonText: 'Herunterladen und ausprobieren',
    },
    cloudPlatform: {
      bannerTitle: 'Zhongze Cloud-Plattform',
      bannerDesc:
        'One-Stop-Tool für Bildungsmanagement: unterstützt Aufgabenverteilung und -abgabe, Gerätemonitoring, Reparaturmeldungen und Parametrierung – für effiziente Verwaltung durch Lehrkräfte, Schüler:innen und Schulen.',
      bannerImageAlt: 'Benutzeroberfläche der Zhongze Cloud-Plattform',
      exploreTitle: 'Unterrichtsmanagement vereinfachen',
      exploreTabs: [
        { name: 'Erstellen' },
        { name: 'Erste Schritte' },
        { name: 'Fortgeschrittenes Lernen' },
      ],
      tabContentAlt: 'Funktionsübersicht',
      introTitle: 'Bildungseffizienz steigern',
      introItems: [
        {
          title: 'Einfache Bedienung',
          desc: 'Ein-Klick-Erstellung: integrierte Bibliothek und Parameterprofile unterstützen Ein-Klick-Produktion und vereinfachen Abläufe. Gerätemonitoring: Überwacht den Gerätestatus in Echtzeit und stellt einen reibungslosen Unterricht sicher.',
        },
        {
          title: 'Zentrale Verwaltung',
          desc: 'Geräteverbund: unterstützt die Kopplung weiterer Geräte im Makerspace; Ein-Klick-Verwaltung erhöht die Effizienz.',
        },
        {
          title: 'Echtzeitüberwachung',
          desc: 'Gerätestatus: Laufzustand in Echtzeit einsehen und bei Störungen sofort eine Reparaturanfrage stellen. Wartung: Das System erinnert basierend auf Laufzeit und Nutzung regelmäßig an Wartungsarbeiten, verlängert die Lebensdauer und verbessert die Schnittqualität.',
        },
      ],
      introImageAlt: 'Zhongze Cloud-Plattform',
      galleryTitle: 'KI-Bildung in die Praxis bringen',
      galleryDesc:
        'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
    },
  },
  eduServices: {
    banner: {
      title: 'KI+Bildung',
      desc: 'Zhongze Lösung für digital-intelligenten Unterricht: unterstützt das Land bei der Ausbildung innovativer Talente, orientiert sich an Bildungsentwicklung und Bedürfnissen der Lernenden und bietet K-12-Schulen KI-Bildungslösungen für alle Jahrgangsstufen.',
      imageAlt: 'Banner der Bildungslösung',
    },
    recommended: {
      title: 'Empfohlene Produkte',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: 'Einen vielseitigen Unterrichtsraum gestalten',
      tabs: {
        'teaching-assist': 'Intelligente Unterrichtsassistenz',
        'process-optimize': 'Optimierung des Unterrichtsablaufs',
        'device-manage': 'Geräteverwaltung',
      },
      tabContents: {
        'teaching-assist': {
          title: 'Intelligente Unterrichtsassistenz',
          features: [
            '·Echtzeitmonitoring & Geräte-/Materialverwaltung',
            '·KI-basierter Lern-/Unterrichtsassistent',
            '·Visualisiertes Dashboard',
          ],
        },
        'process-optimize': {
          title: 'Optimierung des Unterrichtsablaufs',
          features: [
            '·Online-Aufgaben verteilen und korrigieren',
            '·Zentrale Remote-Verwaltung von Kurs-Cloud-Ressourcen',
          ],
        },
        'device-manage': {
          title: 'Geräteverwaltung',
          features: [
            '·Echtzeitmonitoring von Bildungsgeräten',
            '·Remote-Gerätereparaturmeldung',
          ],
        },
      },
      categories: [
        {
          title: 'Online-Aufgaben verteilen und korrigieren',
          description:
            'Intelligentes Aufgabenmanagement erhöht die Unterrichtseffizienz',
        },
        {
          title: 'Remote-Gerätereparaturmeldung',
          description:
            'Bequemer Remote-Service für Wartung und Reparaturmeldungen',
        },
        {
          title: 'Zentrale Remote-Steuerung, Unterrichtsabläufe vereinfachen',
          description:
            'Einheitliche Remote-Management-Plattform optimiert Unterrichtsprozesse',
        },
        {
          title: 'Kurs-Cloud-Ressourcen',
          description:
            'Umfangreiche cloudbasierte Kursressourcen und Unterrichtsmaterialien',
        },
        {
          title: 'Echtzeitmonitoring von Bildungsgeräten',
          description:
            'Überwacht Gerätestatus in Echtzeit und stellt einen reibungslosen Unterricht sicher',
        },
        {
          title: 'KI-gestützter Unterrichtsassistent',
          description:
            'KI-getriebenes System zur intelligenten Unterrichtsunterstützung',
        },
      ],
      solutionCards: [
        { title: 'Digital-intelligente Innovationsbildungslösung' },
        { title: 'Smart-Classroom-Lösung für Grund- und Sekundarschulen' },
        { title: 'Kompetenzlösung für Sek. II & Berufsbildung' },
        { title: 'KI-Klassenzimmer-Lösung für Hochschulen' },
      ],
    },
    solutions: {
      title: 'Bildungslösung aus einer Hand',
      items: [
        {
          title: 'Geräte',
          description:
            'Im Kontext KI-gestützter Bildung wird der Henghao-Laserschneider durch eine intelligente Cloud-Plattform unterstützt und ist eng mit der Zhongze Laser-Lehr-Cloud verknüpft. Lehrkräfte können Geräte aus der Ferne verwalten, Aufgaben verteilen und den Fortschritt der Lernenden nachverfolgen. Diese Integration steigert nicht nur die Unterrichtseffizienz, sondern ermöglicht auch ein stärker personalisiertes Lernerlebnis.',
          buttonText: 'Details ansehen →',
        },
        {
          title: 'Software',
          description:
            'Die Zhongze Bildungsplattform integriert KI-Technologie und bietet personalisiertes Lernen, intelligente Tools, interaktive Erlebnisse und Cloud-Ressourcen. Sie unterstützt Kurs- und Aufgabenmanagement, Gerätemonitoring mit Warnmeldungen sowie Datenanalyse. In Kombination mit der Zhongze Lernplattform (App/PC) und dem Light Maker Tool unterstützt sie den Unterricht ganzheitlich, optimiert Ressourcen, treibt Bildungsinnovation voran und bietet Lehrenden, Lernenden und Bildungseinrichtungen starke Unterstützung.',
          buttonText: 'Details ansehen →',
        },
        {
          title: 'Kurse',
          description:
            'Zhongze Innovations- und Laserschneidkurse: systematische, modulare Kurse speziell für Kinder und Jugendliche, die Interesse und Potenzial wecken. Sie umfassen Technologiegrundlagen, Kreativitäts- und Innovationsdenken, Projektpraxis und wissenschaftliche Experimente – damit Kinder zu zukünftigen Innovations-Talenten werden und gesellschaftliche Entwicklung fördern.',
          buttonText: 'Details ansehen →',
        },
      ],
    },
    managementPlatform: {
      title: 'Zhongze Smartes Unterrichtsmanagement',
      desc: 'Bietet personalisierte Lernpfade, intelligente Unterrichtstools, interaktive Lernerlebnisse und eine Cloud-Ressourcenbibliothek. Unterstützt Kursmanagement, Fortschrittsverfolgung, Online-Aufgaben, Echtzeitüberwachung und Warnmeldungen für Unterrichtsgeräte sowie Datenanalyse. Durch die Integration von KI-Technologie werden Unterrichtsergebnisse verbessert, Bildungsressourcen optimal verteilt und Schüler:innen, Lehrkräfte, Schulen sowie Bildungseinrichtungen umfassend unterstützt – gemeinsam für die Weiterentwicklung und Innovation von Bildung.',
      items: [
        {
          title: 'Digital-intelligente Innovationsbildungslösung',
          alt: 'Digital-intelligente Innovationsbildungslösung',
        },
        {
          title: 'Smart-Classroom-Lösung für Grund- und Sekundarschulen',
          alt: 'Smart-Classroom-Lösung für Grund- und Sekundarschulen',
        },
        {
          title: 'Kompetenzlösung für Sek. II & Berufsbildung',
          alt: 'Kompetenzlösung für Sek. II & Berufsbildung',
        },
        {
          title: 'KI-Klassenzimmer-Lösung für Hochschulen',
          alt: 'KI-Klassenzimmer-Lösung für Hochschulen',
        },
      ],
      action: {
        text: 'Individuelle Lösung anfordern',
        alt: 'Kontakt-Icon',
      },
    },
  },
  makerK12: {
    banner: {
      title: 'Maker Education – K-12',
    },
    intro: {
      title: 'Laserschneider für Bildung und Schulen',
      desc: 'Der Einsatz von Laserschneidern in Schulen ist sicher, kontaktlos und digital – von der Idee bis zum fertigen Produkt. So werden die fantasievollen Einfälle von Kindern ganz leicht Wirklichkeit.',
      imageAlt: 'Laserschneider beim Bau von Architekturmodellen',
    },
    scenesFeatured: {
      title: 'Lernen mit modernsten Bildungstools neu gestalten',
      desc: 'Stellt Schüler:innen branchenführende Technologien bereit, um Kreativität, kritisches Denken und technische Fähigkeiten zu stärken.',
    },
    scenes: {
      items: [
        {
          title: 'Laser-Kreativplattform für jede:n Schüler:in',
          desc: 'Setzt die Leitidee in die Praxis um, stärkt die Beteiligung und ermöglicht es Schüler:innen, im Unterricht mit leistungsstarken Tools kreatives Denken zu entwickeln.',
        },
        {
          title: 'Elektronik- und Programmierkits',
          desc: 'Mit interaktiven Kits können Schüler:innen praktisch programmieren und Robotik sowie KI kennenlernen.',
        },
        {
          title: 'Berufs- und Technikbildung',
          desc: 'Lasertechnologie als Plattform, um berufliche Wege zu ebnen und Kompetenzen zu stärken – angepasst an einen sich wandelnden Arbeitsmarkt und mit mehr Chancen.',
        },
      ],
    },
    solutions: {
      title: 'Architekturmodelle werden in vielen Bereichen eingesetzt',
      items: [
        { title: 'K-12-Schulen/Schulbezirke' },
        { title: 'Weiterbildungsanbieter' },
        { title: 'Forschungslabore & Fachkurse' },
        { title: 'Makerspaces' },
        { title: 'Architekturbibliotheken/Museen' },
        { title: 'Kreativkurse' },
      ],
    },
    bannerLeft: {
      title: 'KI-Bildung in die Praxis bringen',
      subtitle:
        'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
    },
    products: {
      tabs: [
        {
          title: 'Lasergeräte',
          title1: 'Maker-Tool – Laserschneider',
          description:
            'Light 530 und 640 bestehen aus erstklassigen Komponenten und werden mit hochwertigen Fertigungsprozessen sowie strengen Prüfabläufen gefertigt. Das Ergebnis ist ein leistungsstarkes, äußerst stabiles Lasergerät mit präzisem Schneiden und Gravieren, das ideal auf die kreativen Anforderungen von Innovationsbildung zugeschnitten ist.',
        },
        {
          title: 'Software',
          title1: 'Zeichnen leicht gemacht – LightMaker',
          description:
            'Bietet Schüler:innen Sicherheit, Geschwindigkeit und intelligente Funktionen – mit einem der innovativsten Designs am Markt. LightMaker ist mit vielen Designprogrammen kompatibel, darunter AI, PS, CorelDRAW, AutoCAD, Solidworks usw., und unterstützt den Upload hochwertiger Dateien wie JPG, DXF, AI, DST, PNG, BMP, TIF und SVG.',
        },
        {
          title: 'Kurse',
          title1: 'Vielfältiger Unterricht – Innovationsbildungskurse',
          description:
            'Wir wissen: Jedes Kind ist einzigartig. Deshalb sind unsere Kurse flexibel und vielseitig gestaltet, um Interessen und Potenziale jedes einzelnen zu wecken. Inhalte umfassen unter anderem Technologiebasics, Training von Innovationsdenken, Projektpraxis und wissenschaftliche Experimente.',
        },
      ],
    },
    learning: {
      title: 'Wie nutzt man den Zhongze Laserschneider im Unterricht?',
      teacher: {
        title: 'Lehrkräfte',
        lines: [
          'Unterrichtsmaterialien und -zubehör erstellen',
          'Laserschneider helfen Lehrkräften, Lehrmittel und Unterrichtszubehör effizient zu produzieren und eröffnen zugleich neue, innovative Unterrichtsformen.',
        ],
      },
      student: {
        title: 'Schüler:innen',
        lines: [
          'Praktische Fähigkeiten entwickeln',
          'Im Unterricht begleiten Laserschneider Schüler:innen beim Lernen in Design, Ingenieurwesen, Technologie und weiteren Bereichen und helfen dabei, Ideen aus dem Kopf in die Realität umzusetzen.',
        ],
      },
    },
    carousel: {
      items: [
        { alt: 'Szene 1: Architekturmodellbau' },
        { alt: 'Szene 2: Architekturmodellbau' },
        { alt: 'Szene 3: Architekturmodellbau' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: 'Architekturmodelle – Berufsbildung (Sek. II)',
    },
    intro: {
      title:
        'Wie werden Laserschneider für den Bau von Architekturmodellen eingesetzt?',
      desc: 'Sie können Laser zum Schneiden und Gravieren für Architekturmodelle sowie kleinste Teile im Modellbau und in der Spielwarenindustrie einsetzen. Textilien, Kunststoffe, Holz, beschichtete Platten, MDF, PMMA, Karton, Papier, Schaumstoff, Polystyrol, Folien, Acryl u. v. m. lassen sich schnell und präzise laser­schneiden.',
      imageAlt: 'Laserschneider beim Bau von Architekturmodellen',
    },
    scenesFeatured: {
      title: 'Revolutionäre Kraft für den Architekturmodellbau',
      desc: 'Hilft Ihnen, feine Miniaturproben und hochwertige Architekturmodelle zu erstellen und Ihre kreativen Entwürfe detailreich zu präsentieren.',
    },
    scenes: {
      items: [
        {
          title: 'Hohe Präzision',
          desc: 'Laserschneider schneiden Materialien mit sehr hoher Genauigkeit; Abweichungen lassen sich auf ein Minimum begrenzen. So bleiben Bauteile im Architekturmodell maßhaltig und passen perfekt zu den Anforderungen der Konstruktionszeichnung.',
        },
        {
          title: 'Vielfältige Materialien',
          desc: 'Die natürliche Haptik von Holz, die Transparenz und der Glanz von Acryl sowie die Leichtigkeit und Formbarkeit von Papier lassen sich durch Laserschneiden und -gravieren eindrucksvoll hervorheben.',
        },
        {
          title: 'Stark bei komplexen Formen',
          desc: 'Komplexe Geometrien und feine Details – etwa Kurven oder Sonderformen – lassen sich im Architekturmodellbau mit Laserschnitt leicht umsetzen und eröffnen mehr kreativen Spielraum.',
        },
      ],
    },
    solutions: {
      title: 'Architekturmodelle werden in vielen Bereichen eingesetzt',
      items: [
        { title: 'Bildung & akademische Forschung' },
        { title: 'Modellbau & Spielwarenindustrie' },
        { title: 'Dekorelemente & architektonische Besonderheiten' },
        { title: 'Immobilien & Stadtplanung' },
        { title: 'Architekturdekoration & Innenausbau' },
      ],
    },
    bannerLeft: {
      title: 'KI-Bildung in die Praxis bringen',
      subtitle:
        'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
    },
    products: {
      tabs: [
        {
          title: 'Passende Ausrüstung',
          title1: 'Passende Ausrüstung wählen',
          description:
            'Lasergeräte können Ideen von Lernenden schnell in greifbare Ergebnisse verwandeln – ob Modellbau, Design oder künstlerische Kreationen. Von einfachen Bastelarbeiten bis hin zu komplexen mechanischen Entwürfen erledigen Laserschneider und Gravierer Aufgaben präzise und ermöglichen Lernen und Wachstum durch Praxis.',
        },
        {
          title: 'Eigenes Design',
          title1: 'Selbst gestalten',
          description:
            'Designs intuitiv anpassen und das Endergebnis vorab ansehen. Schneiden und reproduzieren Sie Details auf unterschiedlichsten Materialien: Optimieren Sie Ihre Arbeiten mit Text, Logos, Grafiken oder Fotos und dekorieren Sie Architekturmodelle schnell und präzise.',
        },
        {
          title: 'Ihr Markt',
          title1: 'Schüler:innenkompetenzen stärken',
          description:
            'Ein tragbares Laser-Markiergerät, ideal zum Beschriften und für Detailgravuren an Architekturmodellen. Einfach zu bedienen und leicht zu transportieren – ein unverzichtbares Tool für den Architekturunterricht.',
        },
      ],
    },
    learning: {
      title: 'Interdisziplinärer Unterricht',
      groups: [
        {
          title: 'Miniaturmodelle',
          lines: [
            'Präzise und detailreich – für anspruchsvollen Miniaturbau',
            'Feine Lasergravur- und Schnittdetails auf verschiedensten Materialien: weniger aufwendige Schritte, effizientere Fertigung und geringere manuelle Fehler.',
          ],
        },
        {
          title: 'Innenarchitektur',
          lines: [
            'Design-Details sofort richtig: Mit integrierter Kamera lassen sich Position und Größe einfach vorab prüfen – WYSIWYG. Schneiden/Gravieren effizient ausführen und Materialverluste reduzieren.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Szene 1: Architekturmodellbau' },
        { alt: 'Szene 2: Architekturmodellbau' },
        { alt: 'Szene 3: Architekturmodellbau' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: 'Kunst & Kunsthandwerk – Hochschule',
    },
    intro: {
      title: 'Wie verarbeitet man Kunst und Kunsthandwerk mit Lasergeräten?',
      desc: 'Die Geräte bieten Studierenden eine Plattform, um Ideen in reale Werke zu verwandeln, und fördern Innovationsgeist und Kreativität. So lassen sich einzigartige Modelle und Kunstwerke entwerfen, z. B. Laser-Papierschnittarbeiten oder Stempel.',
      imageAlt: 'Lasergeräte bei der Kunst- und Handwerksbearbeitung',
    },
    scenesFeatured: {
      title: 'Technische Kompetenzentwicklung',
      desc: 'Durch die Bedienung von Laserschneid- und Graviergeräten erwerben Studierende vertieftes Wissen über Materialwissenschaften und Fertigungstechniken und verbessern praktische Fähigkeiten sowie Problemlösungskompetenz.',
    },
    scenes: {
      items: [
        {
          title: 'Kreatives Denken anregen',
          desc: 'Laserschneid- und Graviergeräte helfen dabei, kreative Entwürfe umzusetzen – etwa Modelle oder Kunstwerke – und stärken so die Kreativität.',
        },
        {
          title: 'Interdisziplinäre Integration',
          desc: 'Laser­schneiden und -gravieren verbindet Wissen aus Physik, Chemie, Materialwissenschaften, Informatik u. a. Im Hochschulunterricht fördert das die fächerübergreifende Zusammenarbeit und stärkt die umfassenden Kompetenzen der Studierenden.',
        },
        {
          title: 'Praxisorientierte Lehrprojekte',
          desc: 'Laser­schneiden und -gravieren eignet sich für praxisnahe Projekte an Hochschulen, z. B. in der Ingenieurausbildung, im Kunstdesign oder in der Kultur- und Kreativwirtschaft. Studierende können etwa Architekturmodelle, mechanische Bauteile oder Kunstskulpturen herstellen und so Theorie und Praxis verbinden.',
        },
      ],
    },
    solutions: {
      title: 'Anwendungen im Kunsthandwerk an Hochschulen',
      items: [
        { title: 'Individuelle Retail-Produkte' },
        { title: 'Personalisierte Geschenke' },
        { title: 'Saison- und Festtagsmarketing' },
        { title: 'Schmuck & Accessoires' },
        { title: 'Personalisierte Kleidung' },
      ],
    },
    bannerLeft: {
      title: 'KI-Bildung in die Praxis bringen',
      subtitle:
        'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
    },
    products: {
      tabs: [
        {
          title: 'Passende Ausrüstung',
          title1: 'Passende Ausrüstung wählen',
          description:
            'Durch die Wahl geeigneter Laser-Schneid- und Graviergeräte können Hochschulen fortschrittliche Praxiswerkzeuge bereitstellen, die Kreativität fördern und gleichzeitig Unterrichtsqualität sowie Effizienz steigern.',
        },
        {
          title: 'Eigenes Design',
          title1: 'Selbst gestalten',
          description:
            'Designs intuitiv anpassen und das Endergebnis vorab ansehen. Gravieren und reproduzieren Sie Details auf verschiedensten Materialien: Optimieren Sie Ihre Arbeiten mit Text, Logos, Grafiken oder Fotos. Lasergravierer sind sehr einfach zu bedienen und dekorieren Kunstwerke schnell und präzise.',
        },
        {
          title: 'Kunst & Design',
          title1: 'Unterricht in Kunst- und Designstudiengängen',
          description:
            'In Studiengängen wie Kunstdesign und Industriedesign werden Laserschneid- und Graviergeräte häufig in Kurs- und Abschlussprojekten eingesetzt. Studierende können damit Designideen schnell in greifbare Werke überführen und Fähigkeiten zur Prototypenentwicklung trainieren.',
        },
      ],
    },
    learning: {
      title: 'Laser in die Schule bringen',
      groups: [
        {
          title: 'Präzise und effizient – spart Zeit und Aufwand',
          lines: [
            'Zhongze Laserschneider unterstützt Kameravorschau und präzises Ausrichten ohne Materialverschwendung – auch Einsteiger:innen kommen leicht zurecht.',
            'Flüssig und einfach: Material einlegen und kreativ gestalten – WYSIWYG.',
            'Präzise fertigen, jedes Stück Material optimal nutzen – spart Zeit, Aufwand und Material.',
          ],
        },
        {
          title: 'Hohe Leistung – vielfältige Materialien mühelos',
          lines: [
            'Ausgestattet mit einem Hochleistungs-CO₂-Laser – geeignet für Gravur und Schnitt.',
            'Schneidet und graviert Acryl, Holz, Bambus und viele weitere Materialien. Das schafft einen benutzerfreundlichen Workflow für Maker und macht die Umsetzung einfacher und effizienter.',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: 'Szene 1: Kunst- und Handwerksproduktion' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: 'Kultur- & Kreativdesign – Höhere Berufsbildung',
    },
    intro: {
      title: 'Lasergeräte im Kultur- und Kreativdesign',
      desc: 'Studiengänge im Kultur- und Kreativdesign an höheren Berufsbildungs­einrichtungen sind häufig mit fortschrittlichen Laser-Schneid- und Graviergeräten ausgestattet. Diese Geräte decken die Praxisanforderungen der Lernenden in unterschiedlichen Ausbildungsphasen ab.',
      imageAlt: 'Lasergeräte im Kultur- und Kreativdesign',
    },
    scenesFeatured: {
      title: 'Unbegrenzte Möglichkeiten für Kreativität und Qualität eröffnen',
      desc: 'Mit herausragender Leistung und präziser Schnittqualität wird es zu einem unverzichtbaren Werkzeug für Kultur- und Kreativdesigner:innen.',
    },
    scenes: {
      items: [
        {
          title: 'Hochpräziser Schnitt – Design-Details perfekt umgesetzt',
          desc: 'Komplexe, feine Muster und besondere Formen lassen sich mit Laserschneidern detailgetreu umsetzen, sodass jedes Detail präzise im Endprodukt erscheint.',
        },
        {
          title: 'Vielfältige Materialbearbeitung',
          desc: 'Lasergeräte können viele Materialien bearbeiten – z. B. Holz, Acryl, Leder, Metall usw. – und eröffnen damit eine große Auswahl für das Design von Kreativprodukten.',
        },
        {
          title: 'Intelligente Bedienung – vereinfacht die Umsetzung von Ideen',
          desc: 'Lernende geben das fertige Design in den Computer ein, der Laserschneider erkennt es automatisch und schneidet präzise. Diese intelligente Bedienung senkt die Anforderungen an professionelle Bedienkenntnisse und erhöht Stabilität sowie Zuverlässigkeit im Produktionsprozess.',
        },
      ],
    },
    solutions: {
      title: 'Mehr gutes Design in den Alltag bringen',
      items: [
        { title: 'Dekorbilder mit Kulturthemen' },
        { title: 'Kreative Leuchtendesigns' },
        { title: 'Wohn-Deko und Accessoires' },
        { title: 'Stiftehalter & Schreibwaren-Organizer' },
        { title: 'Accessoires im Ethno-Stil' },
        { title: 'Reisesouvenirs' },
      ],
    },
    bannerLeft: {
      title: 'KI-Bildung in die Praxis bringen',
      subtitle:
        'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
    },
    learning: {
      title:
        'Produktionstools im Kultur- und Kreativdesign (Höhere Berufsbildung)',
      groups: [
        {
          title: 'Personalisierung',
          lines: [
            'Laserschneid- und Graviergeräte ermöglichen mühelos die Personalisierung mit Fotos, Namen oder speziellen Motiven und erfüllen den Wunsch nach einzigartigen, erinnerungswürdigen Geschenken.',
            'Beispielsweise lassen sich auf Holz-Deko, Lederaccessoires oder Acryl-Objekten Motive oder Texte nach Kundenvorgabe gravieren – für noch mehr Individualität.',
          ],
        },
        {
          title: 'Merchandise- und Derivatproduktion',
          lines: [
            'Von Museums-Souvenirs bis zu Merchandise aus Film und Animation: Laser­schneiden und -gravieren macht komplexe Designs sichtbar und marktfähig.',
            'Elemente wie Sehenswürdigkeiten, Landmarken und Kultur-IP lassen sich in reale Produkte übersetzen – z. B. aus einer einfachen Holzplatte ein Dekostück mit einzigartigem Muster und Form schneiden oder aus normalem Papier ein filigranes Kunstwerk gravieren.',
          ],
        },
        {
          title: 'DIY-Kreationen',
          lines: [
            'Lasergeräte helfen Maker:innen, DIY-Projekte auf ein höheres Niveau zu bringen – von kleinen Kunsthandwerken bis zu einzigartiger Wohn-Deko lässt sich vieles schnell mit Lasertechnik umsetzen.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Szene 1: Kultur- & Kreativdesign' },
        { alt: 'Szene 2: Kultur- & Kreativdesign' },
        { alt: 'Szene 3: Kultur- & Kreativdesign' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: 'Bildungskooperation',
    },
    advantages: {
      title: 'Unsere Kooperationsvorteile',
      items: [
        {
          title: 'Erfahrenes F&E-Team',
          desc: 'Zhongze Wissenschaft & Bildung verfügt über ein professionelles Team aus Ingenieur:innen und STEM-Bildungsexpert:innen und entwickelt kontinuierlich innovative Produkte, die hohe Bildungsstandards erfüllen und Lernende begeistern.',
        },
        {
          title: 'KI+Bildung: digital-intelligente Unterstützung',
          desc: 'Zhongze Smart-Bildungsplattform: personalisiertes Lernen, intelligente Tools und interaktive Erlebnisse. Unterstützt Kursmanagement, Fortschrittsverfolgung und Aufgabenabgabe sowie Gerätemonitoring und Datenanalyse; umfangreiche Cloud-Ressourcen machen den Unterricht effizienter.',
        },
        {
          title: 'Umfangreiche Kits und Kurssysteme',
          desc: 'Wir bieten Kurse von Einsteiger- bis Fortgeschrittenen­niveau – z. B. zu Laserschneiden, Smart Home, Smart Mobility u. a. – und decken die Bedürfnisse unterschiedlicher Altersgruppen ab.',
        },
      ],
    },
    modes: {
      title: 'Kooperationsmodelle',
      carouselAlts: [
        'Szene der Bildungskooperation',
        'Unterrichtsszene der Bildungskooperation',
        'Praxis der Bildungskooperation',
      ],
      items: [
        {
          title: 'Kursübernahme',
          desc: 'Partnerinstitutionen können unser Kurssystem direkt übernehmen und so die Unterrichtsqualität schnell steigern.',
        },
        {
          title: 'Kits',
          desc: 'Kits speziell für Kinder von 3–16 Jahren: Sichere, leicht zu bedienende Materialien wecken Interesse an Wissenschaft, Technologie, Ingenieurwesen, Kunst und Mathematik (STEAM).',
        },
        {
          title: 'Produktkooperation',
          desc: 'Partnerinstitutionen können unsere Bildungsprodukte wie Laserschneider für Unterricht und Praxisprojekte anschaffen.',
        },
        {
          title: 'Gemeinsame Entwicklung',
          desc: 'Wir begrüßen Partnerinstitutionen, gemeinsam an Kursen und Produkten zu entwickeln und Bildungsinnovation voranzutreiben.',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'KI-Bildung in die Praxis bringen',
        'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: 'Download-Center',
      sectionTitle: 'Software-Download',
      downloadButtonText: 'Client herunterladen',
      softwareList: [
        { name: 'Light maker App' },
        { name: 'Good-laser Light maker' },
        { name: 'Zhongze Lernplattform App' },
        { name: 'Zhongze Lernplattform' },
      ],
    },
    afterSales: {
      bannerTitle: 'After-Sales-Service',
      serviceTitle: 'AR-Smart-Service',
      serviceItems: [
        {
          title: 'Ferndiagnose',
          desc: 'AR-Fernunterstützung: Das Support-Team sieht den Gerätestatus in Echtzeit, diagnostiziert Störungen schnell und gibt präzise Lösungsvorschläge.',
        },
        {
          title: 'Virtuelle Reparatur',
          desc: 'AR-Bedien-Demo: Reparaturschritte werden virtuell angezeigt, anschaulich und leicht verständlich – so lässt sich die Vorgehensweise schnell erlernen.',
        },
        {
          title: 'Intelligentes Tutorial',
          desc: 'AR-interaktives Lernen: Bedienungsanleitungen direkt am Gerät anzeigen – effizient und bequem.',
        },
        {
          title: 'Schnelle Reaktion',
          desc: 'AR-Sofortsupport: Schnelle Rückmeldung, weniger Wartezeit und effizientere Problemlösung.',
        },
      ],
      videosTitle: 'Anleitungsvideos',
      playButtonText: 'Video abspielen',
      videos: [
        { title: 'Unboxing-Video' },
        { title: 'Verbindungsmethoden zur Gerätekommunikation' },
        { title: 'Light 530 Anleitung' },
        { title: 'Unboxing- und Installationsanleitung' },
        { title: 'Grundlagen der Softwarebedienung' },
        { title: 'Fehlerbehebung bei häufigen Problemen' },
      ],
      manualsTitle: 'Bedienungsanleitungen',
      viewPdfButtonText: 'PDF ansehen',
      manuals: [
        { title: 'Light 530 Bedienungsanleitung' },
        { title: 'Light 640 Bedienungsanleitung' },
        { title: 'Blue 530 Benutzerhandbuch' },
        { title: 'M20 Wartungsleitfaden' },
        { title: 'Sicherheits-Handbuch für Laserschneiden' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: 'Drei Kit-Serien',
      bannerDesc:
        'Kits unterstützen personalisiertes Lernen und passen sich unterschiedlichen Altersstufen sowie Lernbedürfnissen an. Gleichzeitig bieten sie Lehrkräften umfangreiche Unterrichtsressourcen und Werkzeuge, um Unterricht und Betreuung effektiver zu gestalten.',
      sections: {
        educationTitle: 'Bildungs-Kits',
        educationDesc: 'Fördert Innovationsdenken und Kreativität',
        creativityTitle: 'Kreativität antreiben, Zukunft gestalten',
        projectsTitle: 'Vielfältige Bildungsprojekte',
      },
      kitsTabs: [
        {
          name: 'Einsteiger-Kit Laserschneiden',
          title:
            'Einsteiger-Kit Laserschneiden\n(passende Holzplatten-Verbrauchsmaterialien)',
          desc: 'STEAM-Kurse zum Laserschneiden – entwickelt auf Basis der Theorie multipler Intelligenzen, der STEAM-Bildungsidee und des projektbasierten Lernens. Für unterschiedliche Altersstufen konzipiert, fördert es Innovationsfähigkeit, kritisches Denken, Problemlösekompetenz sowie Kommunikation und Teamarbeit.',
        },
        {
          name: 'Wunderbare Wissenschaftsbox',
          title:
            'Wunderbare Wissenschaftsbox\n(passende Holzplatten + Mikro-Schaltungs-Kit-Pack)',
          desc: 'Der Kurs orientiert sich am Lehrplanstandard für Naturwissenschaften in der Pflichtschule (Ausgabe 2022) und fördert Kernkompetenzen entlang der vier Dimensionen Wissenschaftskonzepte, wissenschaftliches Denken, forschendes Arbeiten sowie Haltung & Verantwortung. Jede Einheit führt zu einem wissenschaftlichen Werkstück und behandelt zentrale Konzepte wie traditionelle Handwerkskunst, Technik/Engineering und Gesellschaft. Lernende werden angeleitet, wie Wissenschaftler:innen zu denken, ihre Forschungskompetenz zu stärken und wissenschaftliches Denken aufzubauen.',
        },
        {
          name: 'KI-Programmierkit',
          title: 'KI-Programmierkit',
          desc: 'Zukunftstechnologie entdecken – mit dem KI-Programmierkit. Die Kits Smart Farm, Smart Home, Smart Mobility und Smart Factory führen Lernende in Agrartechnologie ein, lassen modernes Leben erleben, erkunden Verkehrseffizienz und erklären intelligente Fertigung. Hands-on-Praxis weckt Innovationsdenken, stärkt Problemlösefähigkeiten und bereitet auf die intelligente Welt vor.',
        },
      ],
      creativityItems: [
        {
          title: 'Praxisfähigkeit stärken',
          desc: 'Diese Kits verbinden STEMA (Wissenschaft, Technologie, Engineering, Kunst, Mathematik). Durch Hands-on-Arbeit und Projektpraxis verbessern sie umfassend die praktische Kompetenz und Problemlösefähigkeit.',
        },
        {
          title: 'Innovationsdenken fördern',
          desc: 'Ermutigt Lernende zu innovativem Design und Experimenten und fördert Innovationsdenken sowie Kreativität. In Teamprojekten werden Kommunikations- und Kooperationsfähigkeiten gestärkt.',
        },
        {
          title: 'Unterrichtsunterstützung für Lehrkräfte',
          desc: 'Unterstützt Lehrkräfte dabei, Lernende zu innovativem Design und Experimenten anzuregen, Innovationsdenken und Kreativität zu fördern und Kommunikations- sowie Kooperationsfähigkeiten in Teamprojekten zu stärken.',
        },
      ],
      projectItems: [
        { title: 'Wissenschaft' },
        { title: 'Technologie' },
        { title: 'Programmieren' },
        { title: 'Kunst' },
      ],
      bottomBannerText:
        'Der Unterricht stärkt durch Hands-on-Arbeit und Projektpraxis die praktische Kompetenz und die Fähigkeit, reale Probleme zu lösen. Er fördert Innovationsdenken und Kreativität und ermutigt zu innovativem Design und Experimenten. Teamprojekte verbessern Kommunikation und Zusammenarbeit und vermitteln kooperatives Arbeiten. Der Kontakt zu neuesten Technologien und Tools hilft Lernenden, sich an die Anforderungen der Zukunft anzupassen.',
    },
    courses: {
      bannerTitle: 'Kursprogramm',
      bannerDesc:
        'Systematische STEAM-Kurse für unterschiedliche Altersstufen – integrieren Wissenschaft, Technologie, Engineering, Kunst und Mathematik und fördern zukünftige Innovationstalente.',
      bannerAlt: 'Kursprogramm',
      bottomBannerAlt: 'Kursprogramm – Kursvorschau',
      sections: {
        kitsTitle: 'Kurs-Kits',
        kitsDesc: 'Perfekte Kombination aus Hardware und Software',
        seriesTitle: 'Premium-Kursserien',
      },
      courseTabs: [
        {
          name: 'Alter 3–6',
          title:
            'Naturwissenschaftliches Entdeckungssystem – Kindergarten (6 Kurse)',
          desc: 'Ausgehend von alltäglichen Phänomenen wird mit Experimentiermaterialien weiter geforscht, um Regeln und Prinzipien der Entwicklung von Dingen zu verstehen.',
        },
        {
          name: 'Alter 6–12',
          title: 'STEAM-Maker-System – Jugendliche (3 Kurse)',
          desc: 'Eigene Ideen entfalten, Geräte anwenden, praktisch umsetzen und Kreativität in Werke verwandeln.',
        },
        {
          name: 'Alter 8–13',
          title: 'Laserschneid-Kursprogramm (3 Kurse)',
          desc: 'Mit Geräten verschiedene Bauteile schneiden, zu 3D-Strukturen montieren und die Struktur gestalten. Programmierkompetenz: Logik und Prinzipien programmatischer Entscheidungen verstehen.',
        },
        {
          name: 'Alter 6–15',
          title: 'KI-Kursprogramm (4 Kurse)',
          desc: 'Mit Geräten und Tools das Aussehen von Werken entwerfen und herstellen und sie durch Programmierung intelligenter und einfacher nutzbar machen, um Probleme aus dem Alltag zu lösen. Programmierkompetenz: Logik und Prinzipien programmatischer Entscheidungen verstehen und Arduino-Programmierung erlernen.',
        },
      ],
      introItems: [
        {
          title: 'Starker Praxisbezug',
          desc: 'Der Kurs legt Wert auf Praxis: Lernende bedienen Laserschneider und andere Geräte selbst und übertragen Theorie in praktische Fertigkeiten.',
        },
        {
          title: 'Innovationsdenken fördern',
          desc: 'Der Kurs ermutigt zu kreativem Design und praktischer Umsetzung und stärkt Innovationsdenken sowie Problemlösefähigkeit.',
        },
        {
          title: 'Projektbasiertes Lernen',
          desc: 'Projektorientiertes Lernen: Durch konkrete Aufgaben lernen und beherrschen Lernende Wissen in der Praxis.',
        },
        {
          title: 'Spitzentechnologie entdecken',
          desc: 'Durch projektbasiertes Lernen erwerben Lernende Wissen und Fähigkeiten praxisnah beim Bearbeiten konkreter Aufgaben.',
        },
        {
          title: 'Systematischer Unterricht',
          desc: 'Vom Einsteiger- bis zum Mittelstufenniveau: systematisches Vermitteln von Laserschneidtechnik und Aufbau einer soliden Wissensbasis.',
        },
        {
          title: 'Spaß und Herausforderung zugleich',
          desc: 'Die Kursgestaltung verbindet Spaß und Herausforderung und weckt Lerninteresse sowie Entdeckerdrang.',
        },
      ],
      courseListRow1: [{ name: 'Smart Farm' }, { name: 'Smart Home' }],
      courseListRow2: [{ name: 'Smart Mobility' }, { name: 'Smart Factory' }],
      bottomBannerText:
        'Der Kurs zeichnet sich durch Praxis, Innovationsdenken und fächerübergreifende Integration aus. Projektbasiertes Lernen hilft Lernenden, Spitzentechnologie mit Spaß und Herausforderung zu beherrschen. In Kombination mit systematischem Unterricht, Sicherheitsschulung und personalisiertem Lernen werden praktische Fähigkeiten, Teamgeist und Problemlösekompetenz aufgebaut. Ergebnispräsentationen werden gefördert und stärken das Erfolgserlebnis.',
    },
    kitsAccessories: {
      bannerTitle: 'Kit-Zubehör',
      accessories: [
        { name: 'RGB-LED-Streifen' },
        { name: 'DS1307 Echtzeituhr-Modul' },
        { name: 'DHT11 Temperatur- und Feuchtigkeitssensor' },
        { name: 'PIR-Bewegungssensor' },
        { name: 'LED-Beleuchtungsmodul' },
        { name: 'Lüftermodul' },
        { name: 'Gabellichtschranke (Optokoppler-Schalter)' },
        { name: 'Tastermodul' },
        { name: 'Controller-Board' },
        { name: 'Erweiterungsboard' },
        { name: 'Regentropfensensor' },
        { name: 'TT-Motor mit Adapterplatine' },
        { name: 'Infrarot-Sensormodul' },
        { name: 'Infrarot-Fernbedienung' },
        { name: 'Gassensor' },
        { name: '4-stelliges 7-Segment-Anzeigemodul' },
        { name: 'Matrix-Tastatur' },
        { name: 'Lichtsensor' },
        { name: 'Ampelmodul' },
        { name: 'Buzzer' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: 'Intelligente Desktop-Laser-Schneid- und Graviermaschine',
      sections: {
        advantages: 'Unsere Vorteile',
        aiTitle: 'KI-Bildung in die Praxis bringen',
        aiSubtitle:
          'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
        carouselTitle: 'Unendliche Möglichkeiten des Gravierens mit Licht',
        specsTitle: 'Produktspezifikationen',
      },
      bannerFeatures: [
        'Punktaufnahme / Konturen nachzeichnen / Sicherheitsschutz',
        'Entwickelt speziell für STEAM-Bildung und Maker',
      ],
      softwareSection: {
        title:
          'Einfach zu bedienen und dennoch leistungsstarkes Laserschneidsystem',
        items: [
          'Für unterschiedliche Materialien lassen sich passende Prozessparameter einstellen, z. B. Schneiden, Tiefgravur, Flachgravur, Scannen usw.',
          'Umfangreiche Vorlagen steigern die Design-Effizienz der Nutzer:innen.',
          'Die Kamera unterstützt Punktaufnahme und Designhilfe – so werden Ideen Realität.',
        ],
      },
      advantages: [
        {
          tagTitle: 'Hochwertiger, hochpräziser Laser',
          desc: 'Zum Beispiel ein original importiertes CO₂-Laserrohr mit 10.640 nm Wellenlänge und 50 W Dauerleistung. Maximale Schnittdicke bis 15 mm (Acryl). Arbeitsgeschwindigkeit bis 1000 mm/s, Wiederholgenauigkeit 0,025 mm. Das gewährleistet Präzision und ermöglicht schnelles, exaktens Schneiden und Gravieren filigraner kreativer Werke.',
        },
        {
          tagTitle: 'Integriertes dreistufiges Abgasfiltersystem',
          desc: 'Integriertes Design aus Filtervlies, Aktivkohle und UV-Ozon-Schicht mit Luftkasten in einem. Das ist sauberer und umweltfreundlicher, zugleich kompakter und praktischer – es wird kein zusätzliches Filtergehäuse benötigt und es spart Platz.',
        },
        {
          tagTitle: 'Sicherheit mit höchster Priorität',
          desc: 'Besteht höchste Sicherheitstests im SGS-Labor; FDA-zertifiziertes Laserprodukt der Klasse I. Ein einzigartiges Sicherheits- und Statusanzeigen-Design macht den Betriebszustand der Maschine intuitiv und klar erkennbar.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          { label: 'Lasertyp', value: 'Versiegeltes CO₂-Glaslaser­rohr' },
          { label: 'Hubweg des Laserkopfes', value: '≤25mm' },
          { label: 'Max. Materialdicke', value: '≤22mm' },
          { label: 'Fokussierung', value: 'Autofokus, manueller Fokus' },
          { label: 'Verbindungsarten', value: 'USB, Ethernet, WLAN' },
          { label: 'Unterstützte Betriebssysteme', value: 'Windows, iOS' },
          {
            label: 'Unterstützte Designsoftware',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks usw.',
          },
          {
            label: 'Unterstützte Dateiformate',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG usw.',
          },
          { label: 'Laserlebensdauer', value: '≤9000 Stunden' },
          {
            label: 'Software-Plattform',
            value: 'LightMaker (Desktop & Mobil), Lightburn (Desktop)',
          },
          {
            label: 'Bedienung/Steuerung',
            value: '5-Zoll-LCD-Touchscreen/Smartphone-App/PC-Software',
          },
          { label: 'Betriebsgeräusch', value: '≤60db' },
          {
            label: 'Antrieb',
            value:
              'Hochgeschwindigkeits-Schrittmotor + hochpräzise Linearführungen + Synchronriemen',
          },
          {
            label: 'Sicherheitsfunktionen',
            value:
              'Interlock-Schalter: Öffnen des Deckels stoppt sofort; Stoß-/Kollisionsstopp; Not-Aus-Taste; Sicherheitsschlüssel; Betriebsstatusanzeige; Übertemperaturalarm des Wassertanks',
          },
          { label: 'Stromversorgung', value: '230V/110VAC 50HZ/60HZ' },
          { label: 'Gewicht', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          {
            label: 'Kühlart',
            value: 'Integriertes Wasserkühlsystem (Aktivwasser)',
          },
          {
            label: 'Betriebsspannung',
            value: 'DC 24V Luftkühlung + Aluminiumrohrschlange',
          },
          { label: 'Tankvolumen', value: '3.2L' },
          { label: 'Max. Förderhöhe', value: '5M' },
          {
            label: 'Durchfluss',
            value: '1000 L/h oder externer CW3000-Laserkühler (optional)',
          },
        ],
        airPumpSpecs: [
          { label: 'Luftfördermenge', value: '50L/min' },
          { label: 'Geräusch', value: '≤48dB' },
          { label: 'Luftdruck', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: 'Nennleistung', value: '62W' },
          { label: 'Luftstrom', value: '280m³/H' },
          { label: 'Geräusch', value: '≤50dB' },
          { label: 'Spannung', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle: 'Wasserkühlsystem (integriert)',
          airPumpTitle: 'Luftpumpe (integriert)',
          airPumpValueOnly: 'AC 220V/110V 16W',
          exhaustTitle:
            'Abluftsystem (extern, integriert) – seitlicher Unterabsaug',
          filterTitle: 'Filtersystem',
          filterValue:
            'Aktivkohle-Filtervlies + leiser Lüfter + industrielles Aktivkohle-Panel',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: 'Intelligente Blaulicht-Laser-Schneid- und Graviermaschine',
      sections: {
        advantages: 'Unsere Vorteile',
        aiTitle: 'KI-Bildung in die Praxis bringen',
        aiSubtitle:
          'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
        carouselTitle: 'Unendliche Möglichkeiten des Gravierens mit Licht',
        specsTitle: 'Produktspezifikationen',
      },
      bannerFeatures: [
        'Bearbeitet viele Materialien',
        'Mit Vertrauen gestalten – jederzeit mühelos kreativ',
      ],
      advantages: [
        {
          tagTitle: 'Kompaktes Design',
          desc: 'Die Blaulicht-Graviermaschine ist stilvoll, modern und kompakt – passend für Zuhause, Schule oder Studio. Das Zusammenspiel aus Metallgehäuse und Acrylabdeckung ermöglicht einen klaren Blick auf den Bearbeitungsprozess.',
        },
        {
          tagTitle: 'Geschlossene Bearbeitung – Schutz vor Verletzungen',
          desc: 'Die Blaulicht-Graviermaschine ist vollständig geschlossen. Wird der Deckel während eines Jobs geöffnet, pausiert sie automatisch. Im Notfall lässt sich die Maschine per Schalter sofort abschalten – ideal für den Einsatz zu Hause und in Schulen.',
        },
        {
          tagTitle:
            'Vielseitige Materialbearbeitung – unterstützt hunderte Materialien',
          desc: 'Erstellen Sie dynamische Produktserien mit einzigartigen Formen oder Stilen. Mit optionalem Zubehör lassen sich auch Materialien in weiteren Formen gravieren – z. B. Becher und runde Objekte – ideal für die Anforderungen kleiner Unternehmen.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: 'Kühlsystem',
          airPumpTitle: 'Luftpumpe',
          airPumpValueOnly: '—',
          exhaustTitle: 'Abluftsystem',
          filterTitle: 'Filtersystem',
          filterValue: '—',
        },
        left: [
          { key: 'laserType', label: 'Lasertyp', value: 'Blaulichtlaser' },
          { key: 'laserPower', label: 'Laserleistung', value: '20W / 40W' },
          {
            key: 'maxCutThickness',
            label: 'Max. Schnittdicke',
            value: '≤10mm',
          },
          { key: 'focusMode', label: 'Fokussierung', value: 'Manueller Fokus' },
          {
            key: 'connection',
            label: 'Verbindungsarten',
            value: 'USB-Verbindung',
          },
          {
            key: 'os',
            label: 'Unterstützte Betriebssysteme',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: 'Software-Plattform',
            value: 'LightBurn (Desktop)',
          },
          {
            key: 'laserLifetime',
            label: 'Laserlebensdauer',
            value: '≥10000 Stunden',
          },
          {
            key: 'maxMaterialThickness',
            label: 'Max. Materialdicke',
            value: '15mm',
          },
          { key: 'noise', label: 'Betriebsgeräusch', value: '≤60dB' },
          {
            key: 'engraveSpeed',
            label: 'Gravurgeschwindigkeit',
            value: '600mm/s',
          },
          {
            key: 'designSoftware',
            label: 'Unterstützte Designsoftware',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks usw.',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'maxSpeed',
            label: 'Max. Arbeitsgeschwindigkeit',
            value: '1000mm/s',
          },
          {
            key: 'power',
            label: 'Stromversorgung',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'workTable',
            label: 'Arbeitsplattformgröße',
            value: '520 × 315mm',
          },
          {
            key: 'accuracy',
            label: 'Positioniergenauigkeit',
            value: '±0.01mm',
          },
          {
            key: 'repeatAccuracy',
            label: 'Wiederholgenauigkeit',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: 'Netzanforderung',
            value: 'AC 220V ±10 %, 50Hz',
          },
          { key: 'totalPower', label: 'Gesamtleistung', value: '300W' },
          {
            key: 'transmission',
            label: 'Antrieb',
            value:
              'Hochgeschwindigkeits-Schrittmotor + hochpräzise Linearführungen + Synchronriemen',
          },
          {
            key: 'safety',
            label: 'Sicherheitsfunktionen',
            value:
              'Deckelverriegelung: Öffnen stoppt; Achs-Endschalter; Not-Aus-Taste; Sicherheitsschlüssel',
          },
          { key: 'weight', label: 'Gewicht', value: '≈50kg' },
          {
            key: 'machineSize',
            label: 'Maschinenabmessungen',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: 'Hochpräzise Laser-Markiermaschine',
      sections: {
        advantages: 'Unsere Vorteile',
        aiTitle: 'KI-Bildung in die Praxis bringen',
        aiSubtitle:
          'KI+Bildung: digitale Intelligenz als Antrieb – innovative Konzepte vereint',
        carouselTitle: 'Laser-Markieren, kreativ personalisieren',
        specsTitle: 'Produktspezifikationen',
      },
      bannerFeatures: [
        'Sicherheitskonzept: Doppel-Schaltersteuerung, Laserschutz',
        'Hochpräzise, schnelle und stabile Gravur- und Schneidleistung',
      ],
      advantages: [
        {
          tagTitle: 'Vielseitige Einsatzszenarien',
          desc: 'Geeignet für zahlreiche Branchen, darunter Schmuckgravur, personalisierte Objekte und Teilekennzeichnung. Es erfüllt Anforderungen von Schmuck und Parfümflakons bis hin zu kleinen industriellen Typenschildern und vielen weiteren kundenspezifischen Gravuren.',
        },
        {
          tagTitle: 'Innovative Anwendung im Bildungsbereich',
          desc: 'Mark M20 bringt industrielle Präzision in den Bildungsbereich und wird zum „Allround-Assistenten“ der Innovationsbildung – von grundlegenden Markierfertigkeiten bis zur Entwicklung komplexer Projekte.',
        },
        {
          tagTitle: 'Kompakt und modern',
          desc: 'Die Mark M20 Laser-Markiermaschine ist kompakt und modern gestaltet, benötigt wenig Platz, arbeitet leise und bietet ein großes Sichtfenster – ausgelegt für hohe Langlebigkeit. Das stilvolle Design erfüllt Sicherheitsstandards und eignet sich für Bildungseinrichtungen und öffentliche Retail-Umgebungen.',
        },
        {
          tagTitle: 'Markieren in Sekunden',
          desc: 'Selbst bei kleinster Schriftgröße markiert Mark M20 in wenigen Sekunden präzise. Diese außergewöhnliche Geschwindigkeit kombiniert mit den vereinfachten Workflows und der Effizienz unserer Laser-Software LightMaker steigert die Produktivität deutlich.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: 'Lasertyp', value: 'Faserlaser' },
          {
            key: 'laserPower',
            label: 'Laserleistung',
            value: '20W / 30W / 50W',
          },
          {
            key: 'markArea',
            label: 'Markierfläche',
            value:
              'Standard 110×110mm (durch Austausch verschiedener F-Theta-Linsen erweiterbar, z. B. 175×175mm usw.)',
          },
          { key: 'maxHeight', label: 'Max. Arbeitshöhe', value: '≤130mm' },
          { key: 'connection', label: 'Verbindungsart', value: 'Ethernet' },
          {
            key: 'os',
            label: 'Unterstützte Betriebssysteme',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: 'Stromversorgung',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: 'Sicherheitsfunktionen',
            value:
              'Stopp beim Öffnen der Abdeckung, Federwellen-Endanschlag, Not-Aus-Taste, Sicherheitsschlüssel',
          },
          {
            key: 'software',
            label: 'Unterstützte Software',
            value: 'Mantimark',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: 'Antriebsart',
            value: 'Hochpräziser elektrischer Spindelhub des Markierkopfs',
          },
          {
            key: 'fileFormat',
            label: 'Unterstützte Dateien',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          {
            key: 'spotSize',
            label: 'Durchmesser des Fokusspots',
            value: '≤20μm',
          },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: 'Intelligente Desktop-Laserschneid- und Gravurmaschine',
      sections: {
        advantages: 'Unsere Vorteile',
        aiTitle: 'KI-Bildung in die Praxis bringen',
        aiSubtitle:
          'KI+Bildung: digitale Intelligenz befähigt, innovative Konzepte integrieren',
        carouselTitle: 'Kreatives Schneiden beginnt hier',
        specsTitle: 'Produktspezifikationen',
      },
      bannerFeatures: [
        'Schnell / offenes Hintertür-Design / effizienter Autofokus',
        'All-in-one Laser-Gravur- und Schneidemaschine',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: 'Arbeitsbereich',
          desc: 'Hervorragende Schneid- und Gravurergebnisse: mehrere Modelle und Laserleistungsoptionen für unterschiedliche Anwendungen\nLasertyp: DC-CO2\nLaserleistung: 60W–130W\nLight640（600*400mm）\nLight960（900*600mm）\nLight1390（1300*900mm）\nLight1610（1600*1000mm）',
        },
        {
          tagTitle: 'Effizienter Autofokus + Rotpunktpositionierung',
          desc: 'Die Autofokus-Funktion fokussiert und positioniert schnell und präzise vor dem Schneiden und Gravieren. In Kombination mit dem Rotpunkt-Lichtstrahl lässt sich die Arbeitsposition in Echtzeit überprüfen. So sparen Sie deutlich Zeit und erzielen bessere Schneid- und Gravurergebnisse.',
        },
        {
          tagTitle: 'Offenes Hintertür-Design',
          desc: 'Das offene Hintertür-Design ermöglicht die Verarbeitung von Materialien mit unbegrenzter Länge. Platten mit 600mm × ∞ Länge machen Ihre Arbeit komfortabler und deutlich weniger eingeschränkt.',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: 'Hervorragende Schneid- und Gravurergebnisse',
            desc: 'Die Laserschneidmaschine ist mit einer hochpräzisen Schneidplattform ausgestattet. Die Bearbeitung von Materialien wie Holz und Acryl erreicht industrielle Standards in Qualität und Effizienz, ermöglicht die Serienfertigung von Laserprodukten und steigert Produktivität sowie Markenwirkung deutlich.',
          },
          {
            tagTitle: 'Hochwertige Laserröhre und präzise Komponenten',
            desc: 'Eine vielfältige Produktlinie ermöglicht die Auswahl unterschiedlicher Lasertypen und Bearbeitungsstärken nach Bedarf. So werden verschiedenste Produktionsanforderungen erfüllt und breitere Anwendungen für Materialien und Verfahren wie Holz, Glas und Acryl unterstützt.',
          },
          {
            tagTitle: 'Strenge Laserqualitätsprüfung, Qualitätssicherung',
            desc: 'Strenge Produktionslinientests, präzise Strahlführung und mehr als fünf Schneid- und Gravurtests stellen eine erstklassige CO2-Laserröhre mit stabiler und gleichmäßiger Leistung sicher. Dank hoher Leistungsstabilität und feinem Laserfokus gelingen gleichmäßige Gravuren – auch mit komplexen Details.',
          },
        ],
        light1390: [
          {
            tagTitle: 'Hervorragende Schneid- und Gravurergebnisse',
            desc: 'Die Laserschneidmaschine ist mit einer hochpräzisen Schneidplattform ausgestattet. Die Bearbeitung von Materialien wie Holz und Acryl erreicht industrielle Standards in Qualität und Effizienz, ermöglicht die Serienfertigung von Laserprodukten und steigert Produktivität sowie Markenwirkung deutlich.',
          },
          {
            tagTitle: 'Hochwertige Laserröhre und präzise Komponenten',
            desc: 'Eine vielfältige Produktlinie ermöglicht die Auswahl unterschiedlicher Lasertypen und Bearbeitungsstärken nach Bedarf. So werden verschiedenste Produktionsanforderungen erfüllt und breitere Anwendungen für Materialien und Verfahren wie Holz, Glas und Acryl unterstützt.',
          },
          {
            tagTitle: 'Strenge Laserqualitätsprüfung, Qualitätssicherung',
            desc: 'Strenge Produktionslinientests, präzise Strahlführung und mehr als fünf Schneid- und Gravurtests stellen eine erstklassige CO2-Laserröhre mit stabiler und gleichmäßiger Leistung sicher. Dank hoher Leistungsstabilität und feinem Laserfokus gelingen gleichmäßige Gravuren – auch mit komplexen Details.',
          },
        ],
        light1610: [
          {
            tagTitle: 'Umfassende und fortschrittliche Sicherheitsfunktionen',
            desc: '1. Not-Aus\n2. Warnleuchte\n3. Wasserdichter Schalter\n4. Erdungsleitung\n5. Integrierter Wärmemelderalarm, der bei abnormalem Betrieb automatisch auslöst\n6. Deckelverriegelung\n7. Robustes Schutzfenster aus gehärtetem Glas',
          },
          {
            tagTitle: 'Langlebig, erstklassige Qualität',
            desc: '1. Ideal für Einzelstücke oder Serienfertigung.\n2. Große Auswahl an Arbeitsbereichen: von 600 × 400mm bis 1600 × 1000mm.\n3. Unvergleichliche Gravurgeschwindigkeit.\n4. Von Branchenexperten entwickelt.\n5. Ideal für personalisierte, Bildungs- und Industrieanwendungen.',
          },
          {
            tagTitle: 'Produktion durch intelligentes Monitoring optimieren',
            desc: 'Entwickelt, um Ihre wertvollsten Komponenten (Achsen, Laserkopf, Optiken, Linsen) vor Staub und Schmutz zu schützen und auch bei intensiver Nutzung jahrelangen, störungsfreien Betrieb zu gewährleisten.',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'Wofür kann Light 640 verwendet werden',
          items: [
            {
              title: 'Light 640 - Projekt 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - Projekt 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - Projekt 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - Projekt 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - Projekt 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - Projekt 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - Projekt 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - Projekt 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'Wofür kann Light 960 verwendet werden',
          items: [
            {
              title: 'Light 960 - Projekt 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - Projekt 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - Projekt 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - Projekt 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - Projekt 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - Projekt 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - Projekt 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - Projekt 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'Wofür kann Light 1390 verwendet werden',
          items: [
            {
              title: 'Light 1390 - Projekt 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - Projekt 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - Projekt 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - Projekt 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - Projekt 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - Projekt 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - Projekt 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - Projekt 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'Wofür kann Light 1610 verwendet werden',
          items: [
            {
              title: 'Light 1610 - Projekt 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - Projekt 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - Projekt 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - Projekt 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - Projekt 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - Projekt 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - Projekt 6',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - Projekt 6',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: 'Kühlsystem',

          exhaustTitle: 'Abluftsystem',
        },
        left: [
          { key: 'model', label: 'Gerätemodell', value: 'Light 640' },
          { key: 'workArea', label: 'Arbeitsfläche', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: 'Lasertyp',
            value: 'Versiegelte CO₂-Glaslaserröhre',
          },
          {
            key: 'laserPower',
            label: 'Laserleistung',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Z-Achsen-Höhe',
            value: '135mm（5.3 in）',
          },
          {
            key: 'tableSize',
            label: 'Tischgröße',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label: 'Max. Materialgröße (Vorder- und Hintertür geschlossen)',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: 'Max. Materialgröße (Hintertür geöffnet)',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: 'Maschinengröße (B × L × H)',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: 'Maschinengewicht',
            value: '300kg（660 lb）',
          },
          {
            key: 'maxSpeed',
            label: 'Max. Arbeitsgeschwindigkeit',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: 'Positioniergenauigkeit',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: 'Fokusmodus',
            value: 'Autofokus / Manueller Fokus',
          },
          {
            key: 'resume',
            label: 'Gravur nach Stromausfall fortsetzen',
            value: 'Unterstützt',
          },
          {
            key: 'transmission',
            label: 'Antriebsart',
            value:
              'Hochgeschwindigkeits-Schrittmotor + hochpräziser Closed-Loop-Motor',
          },
          {
            key: 'connection',
            label: 'Schnittstellen',
            value: 'LAN / USB / WLAN',
          },
        ],
        right: [
          {
            key: 'software',
            label: 'Software',
            value: 'Good-Laser LightMaker (kompatibel mit LightBurn)',
          },
          {
            key: 'process',
            label: 'Bearbeitungsverfahren',
            value: 'Liniengravur, Schneiden, Tiefengravur, Flachgravur',
          },
          {
            key: 'fileFormats',
            label: 'Unterstützte Dateiformate',
            value: 'Bitmap: JPG / PNG / BMP; Vektor: LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: 'Frequenz',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: 'Phase',
            value: 'Einphasig',
          },
          {
            key: 'current',
            label: 'Nennstrom bei Volllast',
            value: '6A',
          },
          {
            key: 'voltage',
            label: 'Spannung',
            value: '230V AC',
          },
          {
            key: 'totalPower',
            label: 'Gesamtleistung',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: 'Geeignete Materialien',
            value:
              'Holz, Acryl, Leder, Stoff, Kunststoff, Karton, Gummi, zweifarbige Gravurplatten, Marmor, Glas, eloxiertes Aluminium sowie weitere nichtmetallische Materialien',
          },
          {
            key: 'safety',
            label: 'Sicherheitsnormen',
            value:
              'Entspricht den EU-CE-Sicherheitsnormen und verfügt über Schutz beim Öffnen der Arbeitskammer, Kalt-/Frostschutzsystem, automatisches Temperaturwarnsystem, Leckstrom-/Leitungsschutzsystem, Not-Aus-Schutzsystem, Strahlführungssystem, Beobachtungssystem aus gehärtetem Glas sowie Betriebsstatusanzeigen usw.',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: 'Kühlart',
            value: 'Wasserkühlung',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: 'Durchmesser des Abluftanschlusses',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: 'Versiegelte CO₂-Glaslaserröhre',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm（5.3 in）',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg（902 lb）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Autofokus / Manueller Fokus',
          resume: 'Unterstützt',
          transmission:
            'Hochgeschwindigkeits-Schrittmotor + hochpräziser Closed-Loop-Motor',
          connection: 'LAN / USB / WLAN',
          software: 'Good-Laser LightMaker (kompatibel mit LightBurn)',
          process: 'Liniengravur, Schneiden, Tiefengravur, Flachgravur',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vektor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Einphasig',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Holz, Acryl, Leder, Stoff, Kunststoff, Karton, Gummi, zweifarbige Gravurplatten, Marmor, Glas, eloxiertes Aluminium sowie weitere nichtmetallische Materialien',
          safety:
            'Entspricht den EU-CE-Sicherheitsnormen und verfügt über Schutz beim Öffnen der Arbeitskammer, Wasserkühlschutzsystem, automatisches Temperaturwarnsystem, Leckstrom-/Leitungsschutzsystem, Not-Aus-Schutzsystem, Strahlführungssystem, Beobachtungssystem aus gehärtetem Glas sowie Betriebsstatusanzeigen usw.',
          coolingMode: 'Wasserkühlung',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: 'Versiegelte CO₂-Glaslaserröhre',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm（5.3 in）',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg（1100 lb）',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Autofokus / Manueller Fokus',
          resume: 'Unterstützt',
          transmission:
            'Hochgeschwindigkeits-Schrittmotor + hochpräziser Closed-Loop-Motor',
          connection: 'LAN / USB / WLAN',
          software: 'Good-Laser LightMaker (kompatibel mit LightBurn)',
          process: 'Liniengravur, Schneiden, Tiefengravur, Flachgravur',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vektor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Einphasig',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Holz, Acryl, Leder, Stoff, Kunststoff, Karton, Gummi, zweifarbige Gravurplatten, Marmor, Glas, eloxiertes Aluminium sowie weitere nichtmetallische Materialien',
          safety:
            'Entspricht den EU-CE-Sicherheitsnormen und verfügt über Schutz beim Öffnen der Arbeitskammer, Wasserkühlschutzsystem, automatisches Temperaturwarnsystem, Leckstrom-/Leitungsschutzsystem, Not-Aus-Schutzsystem, Strahlführungssystem, Beobachtungssystem aus gehärtetem Glas sowie Betriebsstatusanzeigen usw.',
          coolingMode: 'Wasserkühlung',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: 'Versiegelte CO₂-Glaslaserröhre',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm（5.3 in）',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg（1298 lb）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Autofokus / Manueller Fokus',
          resume: 'Unterstützt',
          transmission:
            'Hochgeschwindigkeits-Schrittmotor + hochpräziser Closed-Loop-Motor',
          connection: 'LAN / USB / WLAN',
          software: 'Good-Laser LightMaker (kompatibel mit LightBurn)',
          process: 'Liniengravur, Schneiden, Tiefengravur, Flachgravur',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vektor: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Einphasig',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Holz, Acryl, Leder, Stoff, Kunststoff, Karton, Gummi, zweifarbige Gravurplatten, Marmor, Glas, eloxiertes Aluminium sowie weitere nichtmetallische Materialien',
          safety:
            'Entspricht vollständig den EU-CE-Sicherheitsnormen und verfügt über Schutz beim Öffnen der Abdeckung, Wasserkühlschutz, Temperaturalarm, Leckstromschutz, Not-Aus sowie ein Laser-Sicherheitskreissystem',
          coolingMode: 'Wasserkühlung',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: 'Ihre E-Mail-Adresse',
      button: 'Abonnieren',
    },
    social: {
      tiktok: 'TikTok',
      weibo: 'WeChat Channels',
      wechat: 'WeChat',
      redbook: 'Xiaohongshu',
    },
    companyDesc:
      'Fokussiert auf Technologie- und Kreativitätsbildung für Kinder und Jugendliche von 3 bis 16 Jahren: Aufbau von Innovationslernräumen, eigenständige Entwicklung von STEAM-Bildungsprodukten und -kursen, mit Modulen rund um Designsoftware, Lasergravur, Programmierung u. a.',
    navColumns: [
      {
        title: 'Produkte',
        items: [
          { label: 'Geräte', to: '/product/light530' },
          { label: 'Kits', to: '/product/kits' },
          { label: 'Kurse', to: '/product/courses' },
        ],
      },
      {
        title: 'Software',
        items: [
          {
            label: 'Zhongze STEAM Cloud-Plattform',
            to: '/software/cloud-platform',
          },
          {
            label: 'Zhongze STEAM Lernplattform',
            to: '/software/learning-platform',
          },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: 'Bildungsservices',
        items: [
          { label: 'KI-Bildungslösung', to: '/edu-services' },
          {
            label: 'Maker-Bildung – Grund- und Sekundarschulen',
            to: '/edu-services/maker-k12',
          },
          {
            label: 'Architekturmodelle – Berufsbildung',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: 'Kreativdesign – höhere Berufsbildung',
            to: '/edu-services/cultural-higher-vocational',
          },
          {
            label: 'Kunst und Handwerk – Hochschulen',
            to: '/edu-services/arts-university',
          },
          { label: 'Innovationsraum', to: '/edu-services' },
        ],
      },
      {
        title: 'Service & Support',
        items: [
          { label: 'Download-Center', to: '/support/download' },
          { label: 'After-Sales-Service', to: '/support/after-sales' },
        ],
      },
      {
        title: 'Bildungskooperation',
        items: [
          { label: 'Bildungskooperation', to: '/edu-services/cooperation' },
        ],
      },
      {
        title: 'Über uns',
        items: [
          { label: 'Über uns', to: '/about' },
          { label: 'News', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: 'Verkaufshotline: 18379276683',
      email: 'E-Mail: sam@zz-steam.com',
      address:
        'Adresse: Huashengda Building, Tower A, Bagua 4th Rd., Futian, Shenzhen',
    },
    qrDesc: 'Mehr erfahren',
  },

  globalContactForm: {
    title: 'Kontaktieren Sie uns',
    subtitle:
      'Bitte füllen Sie das folgende Formular aus, wir melden uns schnellstmöglich bei Ihnen',
    fields: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      company: 'Unternehmen',
      message: 'Nachricht',
    },
    placeholders: {
      name: 'Bitte geben Sie Ihren Namen ein',
      email: 'Bitte geben Sie Ihre E-Mail ein',
      phone: 'Bitte geben Sie Ihre Telefonnummer ein',
      company: 'Bitte geben Sie Ihren Firmennamen ein',
      message: 'Bitte geben Sie Ihre Nachricht ein',
    },
    submitting: 'Wird gesendet...',
    submit: 'Senden',
    visual: {
      title: 'Wir freuen uns auf die Zusammenarbeit',
      description:
        'Wir bieten professionellen Service und Support. Wenn Sie Fragen haben, kontaktieren Sie uns jederzeit.',
    },
    contact: {
      phone: 'Telefon',
      email: 'E-Mail',
    },
    validation: {
      name: 'Bitte geben Sie Ihren Namen ein',
      email: 'Bitte geben Sie Ihre E-Mail ein',
      emailFormat: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      phone: 'Bitte geben Sie Ihre Telefonnummer ein',
      phoneFormat: 'Bitte geben Sie eine gültige Telefonnummer ein',
      message: 'Bitte geben Sie Ihre Nachricht ein',
    },
    success: 'Erfolgreich gesendet! Wir melden uns schnellstmöglich bei Ihnen.',
    networkError: 'Senden fehlgeschlagen, bitte später erneut versuchen.',
  },
};
